import { render, staticRenderFns } from "./taskInfo.vue?vue&type=template&id=28213abe&scoped=true"
import script from "./taskInfo.vue?vue&type=script&lang=js"
export * from "./taskInfo.vue?vue&type=script&lang=js"
import style0 from "./taskInfo.vue?vue&type=style&index=0&id=28213abe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28213abe",
  null
  
)

export default component.exports